import { getDomComplete } from './performanceListener';

const onDomComplete = response => {
  getDomComplete().then(domComplete => response(domComplete));
};

export default onDomComplete;
